<template>
  <b-form-group>
    <div class="c-smart-select" :class="focused ? 'active' : ''">
      <div>
        <b-input-group class="search__box__control" :class="focused ? 'active' : ''">
          <div class="input-group-prepend">
            <span class="input-group-text" :class="disabled ? 'disabled' : ''"><i class="fa fa-search"></i></span>
          </div>
          <input class="form-control" ref="searchBox" v-model="filterFormModel.keyword"
                 :placeholder="$t('productSearchPlaceholder')" autocomplete="off" :disabled="disabled"
                 @keyup="search" @focus="focus" @click="focus" />
        </b-input-group>

        <div class="c-smart-select__list search__box shadow" v-if="focused">
          <div v-if="listLoading" class="col-12 text-center">
            <b-spinner small></b-spinner>
          </div>
          <div class="col-12 text-center text-danger py-4" v-else-if="!itemCount && !listLoading">
            <span>{{ $t('notFoundSearch') }}</span>
          </div>
          <ul class="list-group">
            <template v-for="item in items">
              <li :key="item._id" class="list-group-item list-group-item-action" @click="selectItem(item)">
                <div class="d-flex justify-content-between align-items-center">
                  <div>
                    <span class="text-gray-999 border bg-light">{{ item.sku }}</span>&nbsp;
                    <span class="text-primary" style="font-size: 1.2em">{{ item.name }}</span>
                  </div>
                  <div>
                    <b class="text-gray-999">{{ $t('sellPrice') }}:&nbsp;</b>
                    <span class="font_1_2_em">{{ item.sellPrice | numFormat }}&nbsp;&#8363;</span>
                  </div>
                </div>
              </li>
            </template>
          </ul>
        </div>
      </div>
    </div>
  </b-form-group>
</template>

<script>
import list from '@/mixins/List'
import _ from 'lodash'

export default {
  mixins: [list],
  props: ['disabled'],
  data() {
    return {
      service: '/admin-product',
      autoLoad: false,
      defaultFilterFormModel: {
        keyword: '',
        active: 'activated'
      },
      focused: false
    }
  },
  methods: {
    load() {
      let loadingDelay = _.delay(() => {
        this.listLoading = true
      }, 250)

      let filter = { ...this.filterFormModel }

      this.$service.get(this.service, { params: filter }).then(response => {
        this.apply(response.data)
      }).catch(error => {
        if (error.response.data.message) {
          this.$swal({
            text: error.response.data.message,
            icon: 'error'
          })
        }
      }).finally(() => {
        clearTimeout(loadingDelay)
        this.listLoading = false
        if (this.afterLoad) {
          this.afterLoad()
        }
      })
    },
    focus() {
      this.focused = true
      this.load()
      this.$nextTick(() => this.$refs.searchBox.focus())
    },
    hide() {
      this.focused = false
    },
    search: _.debounce(function() {
      this.load()
    }, 200),
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.hide()
      }
    },
    selectItem(item) {
      this.$emit('select', item)
      this.focused = false
    }
  },
  i18n: {
    messages: {
      en: {
        productSearchPlaceholder: 'Enter the product name or code',
        sellPrice: 'Sell price'
      },
      vi: {
        productSearchPlaceholder: 'Nhập tên hoặc mã của sản phẩm',
        sellPrice: 'Giá bán'
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
  }
}
</script>

<style scoped>
.c-smart-select {
  border: none;
}

.search__box__control .form-control {
  outline: none;
  box-shadow: none;
  border: 1px solid #ced4da;
  border-left: none;
  padding-left: 2px;
}

.search__box__control .input-group-text {
  border: 1px solid #ced4da;
  border-right: none;
  background-color: #fff;
  font-size: 1.3em;
}

.search__box__control .input-group-text.disabled {
  background-color: #e9ecef !important;
}

.search__box__control .input-group-text i:before {
  color: #ced4da;
}

.search__box__control.active .input-group-text {
  border: 1px solid #6B66C4;
  border-right: 0;
}

.search__box__control.active .form-control {
  border: 1px solid #6B66C4;
  border-left: none;
}

.search__box {
  position: absolute;
  width: 100%;
  z-index: 1000;
  background-color: white;
  padding-top: 4px;
  margin-top: 4px;
  box-shadow: 5px 5px 10px #888888;
  border-left: 2px solid #ced4da;
  border-right: 2px solid #ced4da;
}

.font_1_2_em {
  font-size: 1.2em;
}

.c-smart-select__list {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 60vh;
  border: 1px solid #E4E4E4;
  z-index: 2;
  transition: all 0.2s ease;
}

.list-group-item:hover {
  background-color: #f8f9fa;
  cursor: pointer;
}
</style>